import React, { useState } from 'react';
import Navbar from '../components/Layout/Navbar';
import HeroCarousel from '../components/Home/HeroCarousel';
import FeatureGrid from '../components/Home/FeatureGrid';
import Testimonials from '../components/Home/Testimonials';
import Footer from '../components/Layout/Footer';
import CaseStudiesContent from '../pages/CaseStudiesPage';
import AboutContent from '../pages/AboutPage';
import UserManualContent from '../pages/UserManualPage';
import './Home.css';

// 用户信息接口
interface UserInfo {
  username: string;
  storeUserName?: string;
}

type TabType = 'home' | 'case-studies' | 'about' | 'user-manual';

interface HomeProps {
  onOpenLoginModal?: (type: 'merchant' | 'company') => void;
  userInfo?: UserInfo | null;
  onLogout?: () => void;
}

const Home: React.FC<HomeProps> = ({ onOpenLoginModal, userInfo, onLogout }) => {
  const [activeTab, setActiveTab] = useState<TabType>('home');

  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="home-page">
      <Navbar
        onOpenLoginModal={onOpenLoginModal}
        userInfo={userInfo}
        onLogout={onLogout}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === 'home' && (
        <>
          <HeroCarousel />
          <FeatureGrid />
          <Testimonials />
        </>
      )}

      {activeTab === 'case-studies' && (
        <div className="page-content-wrapper">
          <CaseStudiesContent />
        </div>
      )}

      {activeTab === 'about' && (
        <div className="page-content-wrapper">
          <AboutContent />
        </div>
      )}

      {activeTab === 'user-manual' && (
        <div className="page-content-wrapper">
          <UserManualContent />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Home;
